import { Component, ContentChildren, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ThemePalette } from '@angular/material';
import { SplitButtonActionDirective } from '@app/shared/directives/split-button-action/split-button-action.directive';

@Component({
  selector: 'app-split-button',
  templateUrl: './split-button.component.html',
  styleUrls: ['./split-button.component.scss'],
})
export class SplitButtonComponent implements OnInit {
  @ContentChildren(SplitButtonActionDirective) actionItems: SplitButtonActionDirective[];
  @Input() color: ThemePalette;
  @Input() disabled: boolean;
  @Input() type = 'button';
  @Output() defaultAction = new EventEmitter<void>();
  @Output() action = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}
}
